<template>
    <div>
       <BreadcrumbsProject
          v-if="!isDeluxeLayout"
          :breadcrumbs="[
            {
                link : dotnetUrl +'/project/list',
                title : $t('Projects'),
                isRouterLink: false
            },
            {
                link : projectUrl +'/Project/' + projectInfo._id,
                title : (projectInfo.projectNumber || '-') +' ' + (projectInfo.projectName || ''),
                isRouterLink: false
            },
            {
                link : '/boq/' + projectInfo._id,
                title : $t('Bill of Quantities'),
                isRouterLink: true
            },
            {
                link : '/boq/builder/' + boqItemData._id,
                title :(boqItemData.name || '-')  ,
                isRouterLink: true
            },
            {
                link : '/boq/builder/' + boqItemData._id + '/breakdown/' + parentId,
                title : parentObj.name ,
                isRouterLink: true
            }
          ]"
      ></BreadcrumbsProject>
    </div>

  
    <div class="boq-preliminaries-page">
      <router-link
        v-if="isDeluxeLayout"
        class="boq-preliminaries-back boq-preliminaries-back--outside d-print-none"
        :to="{ name: 'BoqBuilder', params: { id: boqItemData._id } }"
      >
        <i class="fa-solid fa-chevron-left"></i>
        <span>{{ $t('Back to') }} {{ boqItemData.name || $t('Bill of Quantities') }}</span>
      </router-link>

      <div class="boq-preliminaries-panel">
        <div class="boq-preliminaries-hero">
          <div class="boq-preliminaries-hero__main">
            <span class="boq-preliminaries-eyebrow">{{ $t('Bill of Quantity') }}</span>
            <h1>{{ parentObj.name || '-' }}</h1>

            <div class="boq-preliminaries-reference" v-if="referenceTitle">
              <span>{{ $t('Reference') }}:</span>
              <strong>
                {{ referenceTitle }}
                <em v-if="referenceStatusLabel">({{ referenceStatusLabel }})</em>
              </strong>
            </div>
          </div>

          <div class="boq-preliminaries-hero__side d-print-none">
            <span :class="['boq-preliminaries-status', GetBoqStatusClass(boqItemData.approvalStage)]">
              {{ FormatStatusLabel(ApprovalStageBoqObj[boqItemData.approvalStage - 1]?.name) }}
            </span>
          </div>
        </div>

        <div class="boq-preliminaries-body">
          <div class="boq-preliminaries-toolbar">
            <div class="boq-preliminaries-disclaimer">
              <FigureCurrencyNote :currency="boqItemData.currencyId" />
            </div>

            <div class="boq-preliminaries-toolbar__actions d-print-none">
              <div class="boq-preliminaries-action-group">
                <button
                  class="btn boq-preliminaries-action boq-preliminaries-action--ghost"
                  @click="()=>{ OpenFilter = !OpenFilter}"
                >
                  <i class="fa-solid fa-filter"></i>
                  <span>{{ $t('Filter') }}</span>
                </button>
                <button
                  class="btn boq-preliminaries-action boq-preliminaries-action--ghost"
                  :title="$t('Filter Columns')"
                  data-bs-toggle="modal"
                  data-bs-target="#BoqColumnFilter"
                >
                  <i class="fas fa-eye-slash"></i>
                  <span>{{ $t('Columns') }}</span>
                </button>
              </div>

              <div class="boq-preliminaries-action-group boq-preliminaries-action-group--end">
                <template v-if="haveChanges">
                  <button class="btn boq-preliminaries-action boq-preliminaries-action--cancel" @click="CancelSaveSequence">
                    <i class="fa-solid fa-ban"></i>
                    <span>{{ $t('Cancel') }}</span>
                  </button>
                  <button class="btn boq-preliminaries-action boq-preliminaries-action--primary" @click="SaveSequences">
                    <i class="fa-solid fa-list-ol"></i>
                    <span>{{ $t('Save Sequence') }}</span>
                  </button>
                </template>

                <template v-else-if="!IsQuotationPublished">
                <button
                  class="btn boq-preliminaries-action boq-preliminaries-action--primary"
                  data-bs-toggle="modal"
                  data-bs-target="#BoqMoveLineItemsModal"
                  v-if="permission.indexOf(ModuleActionList.BOQ_EDIT) >-1 && selectedToBeMoved.length!=0"
                >
                  <i class="fa-solid fa-link"></i>
                  <span>{{ $t('Move Line Items') }}</span>
                </button>

                

                <button
                  class="btn boq-preliminaries-action boq-preliminaries-action--danger"
                  data-bs-toggle="modal"
                  data-bs-target="#BoqDeleteLineItemsModal"
                  v-if="permission.indexOf(ModuleActionList.BOQ_EDIT) >-1 && selectedToBeMoved.length!=0"
                >
                  <i class="fa-solid fa-trash-can"></i>
                  <span>{{ $t('Delete Line Items') }}</span>
                </button>

                <button
                  class="btn boq-preliminaries-action boq-preliminaries-action--primary"
                  data-bs-toggle="modal"
                  data-bs-target="#BoqProcureLineItemsModal"
                  @click="OpenProcureLineItems"
                  v-if="permission.indexOf(ModuleActionList.BOQ_EDIT) >-1 && selectedToBeMoved.length!=0"
                >
                  <i class="fa-solid fa-cart-shopping"></i>
                  <span>{{ $t('Procure Line Items') }}</span>
                </button>

                <button
                  class="btn boq-preliminaries-action boq-preliminaries-action--primary"
                  @click="OpenAddItemModal"
                  data-bs-toggle="modal"
                  data-bs-target="#ModalNewLineItem"
                  v-if="permission.indexOf(ModuleActionList.BOQ_EDIT) >-1 && selectedToBeMoved.length==0"
                >
                  <i class="fa-solid fa-plus"></i>
                  <span>{{ $t('Add Line Item') }}</span>
                </button>

                <ButtonTemplateDownloader
                  standard
                  group-class="boq-preliminaries-template-group"
                  button-class="boq-preliminaries-action boq-preliminaries-action--primary"
                />

                <button
                  class="btn boq-preliminaries-action boq-preliminaries-action--primary"
                  data-bs-toggle="modal"
                  data-bs-target="#ModalImportBoq"
                  v-if="permission.indexOf(ModuleActionList.BOQ_EDIT) >-1"
                  @click="OpenImportModal"
                  :title="$t('Import File')"
                >
                  <i class="fa-solid fa-file-import"></i>
                  <span>{{ $t('Import') }}</span>
                </button>
                </template>

                <button
                  type="button"
                  class="btn boq-preliminaries-action boq-preliminaries-action--export"
                  data-bs-toggle="modal"
                  data-bs-target="#BoqExportBoqList"
                >
                  <span>{{ $t('Export') }}</span>
                  <i class="fa-solid fa-arrow-up-right-from-square"></i>
                </button>
                <button
                  type="button"
                  class="btn boq-preliminaries-action boq-preliminaries-action--print"
                  @click="PrintPage"
                >
                  <span>{{ $t('Print') }}</span>
                  <i class="fa-solid fa-print"></i>
                </button>
              </div>
            </div>
          </div>

          <div :class="['row', { 'boq-preliminaries-filter-panel': OpenFilter }]">
            <div class="col-md-6 pb-2" v-if="OpenFilter">
              <div class="form-group boq-preliminaries-filter-field">
                <label class="d-flex justify-content-between">
                    <a>{{ $t('Cost Category') }}</a>
                    <span role="button" class="text-danger text-decoration-underline" @click="ClearField(2)"><i class="fa-solid fa-xmark "></i> {{ $t('Clear Field') }}</span>
                </label>
                <Multiselect
                :multiple="true" :options="dataCostCodes"
                :internalSearch="false"
                :placeholder="$t('Search Here')"
                v-model="selectedCostCode" :loading="searchCostCodeLoading"
                 :max-height="300"
                label="costName" track-by="_id"/>
              </div>
            </div>
            <div class="col-md-6 pb-2" v-if="OpenFilter">
              <div class="form-group boq-preliminaries-filter-field">
                <label class="d-flex justify-content-between">
                  <a>{{ $t('Space ID') }}</a>
                  <span role="button" class="text-danger text-decoration-underline" @click="ClearField(1)"><i class="fa-solid fa-xmark "></i> {{ $t('Clear Field') }}</span>
                </label>
                <Multiselect
                :multiple="true" :options="areaList"
                :placeholder="$t('Search Here')"
                v-model="selectedArea"  :max-height="300" />
              </div>
            </div>
          </div>

          <Loader v-if="tableLoading" />
          <div v-else-if="dataReady" ref="printTableShell" class="boq-preliminaries-table-shell">
            <BoqItemTableBreakdown class="boq-preliminaries-table" ref="tableBreakdown" :boqId="boqItemData._id" :rowDatas="rowDatas" :reloadData="ReloadList" :stage="boqItemData.approvalStage"
            :OpenEditModal="OpenEditLineItem" :SyncSelectedLineItem="SyncSelectedLineItem" :IsQuotationPublished="IsQuotationPublished"
            :measurementUnits="measurementUnits" :selectedColumns="selectedColumns" :updateSelected="UpdateSelected" :BoqCategoryList="BoqCategoryList" :GetChanges="GetChanges" :GetSequence="GetSequence" :sections="rawSections" />
          </div>
        </div>
      </div>
    </div>
    <Modal idModal="BoqReviewModal" headerTitle="Send For Review BoQ" v-if="permission.indexOf(ModuleActionList.BOQ_PUBLISH) >-1">
      <div>
         <div class="form-group">
              <label class="required-style">Date End </label>
              <input type="date" v-model="boqPublishData.dateEnd" class="form-control"/> 
              <small class="text-warning" v-if="isPublishClicked && !boqPublishData.dateEnd">Required</small>
          </div>
         <div class="form-group">
              <label class="required-style">Process </label>
              <Select2
                  :dataOptions="reviewProcessList"
                  indexValue="_id"
                  labelName="processName"
                  placeHolder="Search Process Here"
                  v-model:optionValue="boqPublishData.processId"
                  ref="selectCostCode"
              >
              </Select2>
              <a class="text-primary small"  :href="projectUrl +'/Project/' + projectInfo._id+'/process'">No Process on the list? Click here to Create</a>
              <small class="text-warning" v-if="isPublishClicked && !boqPublishData.processId">Required</small>
          </div>
      </div>
      <template v-slot:actions>
        <button type="button" ref="closeBoqPublishModal" class="btn btn-outline-danger" data-bs-dismiss="modal">X Cancel</button>
        <button type="button" class="btn btn-primary"  @click="ReviewBoqRun"><i class="fas fa-save"></i> Send for Review</button>
      </template>
    </Modal>
    <Modal idModal="BoqApprovalModal" headerTitle="Send For Approval BoQ" v-if="permission.indexOf(ModuleActionList.BOQ_PUBLISH) >-1">
        <div>
         <div class="form-group">
              <label class="required-style">Date End </label>
              <input type="date" v-model="boqApprovalData.dateEnd" class="form-control"/> 
              <small class="text-warning" v-if="isApprovalClicked && !boqApprovalData.dateEnd">Required</small>
          </div>
         <div class="form-group">
              <label class="required-style">Process </label>
              <Select2
                  :dataOptions="approvalProcessList"
                  indexValue="_id"
                  labelName="processName"
                  placeHolder="Search Process Here"
                  v-model:optionValue="boqApprovalData.processId"
                  
              >
              </Select2>
              <a class="text-primary small"  :href="projectUrl +'/Project/' + projectInfo._id+'/process'">No Process on the list? Click here to Create</a>
              <small class="text-warning" v-if="isApprovalClicked && !boqApprovalData.processId">Required</small>
          </div>
        </div>
        <template v-slot:actions>
          <button type="button" ref="closeBoqApprovalModal" class="btn btn-outline-danger" data-bs-dismiss="modal">X Cancel</button>
          <button type="button" class="btn btn-primary"  @click="ForApprovalBoqRun"><i class="fas fa-save"></i> Send for Approval</button>
        </template>
    </Modal>
    <Modal idModal="BoqExportBoqList" headerTitle="Export BoQ"  >
        <div>
            <div class="form-group">
                <label class="required-style">Template </label>
                <select class="form-select" v-model="exportTemplateType" :disabled="isExportRunning">
                    <option v-for="(item,key) in ExportTemplatesForExport" :key="key" :value="key">{{item}}</option>
                </select>
            </div>
            <!-- <div class="form-group">
                <label >Filter </label>
                <Multiselect 
                :options="dataCostCodes" 
                placeholder="Type Here to search by Cost Category"
                v-model="exportTemplateFilter"  @search-change="SearchCostCodeAll" :searchable="true" 
                :internalSearch="false" :loading="searchCostCodeLoading"
                :clear-on-select="false" :max-height="300"
                label="costName" track-by="_id"/>
            </div> -->
        </div>
        <template v-slot:actions>
            <div>
                <!-- <button type="button" class="btn btn-outline-primary" @click="ExportForClient" >
                    <i class="fa-solid fa-user-tie"></i>  Export for Client
                </button> -->
            </div>
            <button type="button" :class="isDeluxeLayout ? 'custom-btn' : 'btn btn-primary'" :disabled="isExportRunning" @click="ExportBoqList">
                <i v-if="!isExportRunning" class="fa-solid fa-file-arrow-down"></i>
                <span>{{ $t('Export') }}</span>
                <span v-if="isExportRunning" class="spinner-border spinner-border-sm ms-2" aria-hidden="true"></span>
                <span v-if="isExportRunning" class="visually-hidden" role="status">{{ $t('Loading') }}</span>
            </button>
        </template>
    </Modal>
    <Modal idModal="BoqGroupList" headerTitle="Select Line Item Parent"  v-if="permission.indexOf(ModuleActionList.BOQ_EDIT) >-1"  >
        <div>
            <div class="" v-for="(item,key) in selectedLineItems" :key="key">
              <input type="radio" :id="key + '-radio'" :value="item._id" v-model="selectedParent" />
              <label class="ps-3 h6 fw-normal" :for="key + '-radio'">{{item.costCode}} {{item.name}}</label>
            </div>
            
        </div>
        <template v-slot:actions>
            <div>
                
            </div>
            <button type="button" class="btn btn-primary"  >
                <i class="fas fa-save"></i> Group
            </button>
        </template>
    </Modal>
    <ModalLineItemColumnFilter :UpdateSelectedColumn="ChangeSelectecColumnValue"/>
  
    <ModalNewLineItem
    v-if="permission.indexOf(ModuleActionList.BOQ_EDIT) >-1 && boqItemData._id != 1"
    ref="modalNewLineItem"
    :boqList="boqList" :ResetData="GetDataList" :boqId="boqItemData._id" :parentId="parentId" />
  
    <ModalImportLineItems
    
    v-if="boqItemData.projectId && permission.indexOf(ModuleActionList.BOQ_EDIT) >-1"
    ref="modalImportLineItem"
    :boqList="boqList" :ResetData="GetDataList" :boqId="boqItemData._id" :projectId="boqItemData.projectId" :parentId="parentId" />
  
    <ModalUpdateLineItem
    v-if="permission.indexOf(ModuleActionList.BOQ_EDIT) >-1 && boqItemData._id != 1"
    :selectedLineItem="updateLineItem" :boqId="boqItemData._id" 
    :boqList="boqList" :ResetData="GetDataList" />
    <Modal idModal="BoqMoveLineItemsModal" headerTitle="Move to Another Section" modalSize="modal-md" >
        <div class="boq-move-modal">
        <div class="boq-move-modal__remark">
            <span class="boq-move-modal__remark-icon">
                <i class="fa-solid fa-circle-info"></i>
            </span>
            <div>
                <strong>Move selected line items</strong>
                <small>Selected line items will be moved into the chosen section. Existing quantities, rates, and remarks will stay unchanged.</small>
            </div>
        </div>
        <div class="form-group boq-move-modal__field">
            <label>Main Section</label>
            <select class="form-select boq-move-modal__input" v-model="selectedFirstSection" @change="ChangeSection(1)">
                <option value="">Please Select</option>
                <option :value="item._id" v-for="(item,key) in firstSections" class="text-capitalize" :key="key"> {{ item.name }}</option>
            </select>
        </div>
        <div class="form-group boq-move-modal__field" v-if="secondSections.length!=0">
            <label>Sub Section</label>
            <select class="form-select boq-move-modal__input" v-model="selectedSecondSection" @change="ChangeSection(2)">
                <option value="">Please Select</option>
                <option :value="item._id" v-for="(item,key) in secondSections" class="text-capitalize" :key="key"> {{ item.name }}</option>
            </select>
        </div>
        <small class="boq-move-modal__hint" v-if="selectedFirstSection && !selectedSecondSection && !selectedThirdSection">
            Main sections are for grouping only. Please select or add a sub-section before moving line items.
        </small>
        <div class="form-group boq-move-modal__field" v-if="thirdSections.length!=0">
            <label>Sub Section</label>
            <select class="form-select boq-move-modal__input" v-model="selectedThirdSection">
                <option value="">Please Select</option>
                <option :value="item._id" v-for="(item,key) in thirdSections" class="text-capitalize" :key="key"> {{ item.name }}</option>
            </select>
        </div>
        <div class="form-group boq-move-modal__field">
            <label>Selected Line Items To be Moved</label>
            <div class="boq-move-modal__count">
                <i class="fa-solid fa-list-check"></i>
                <span>{{ selectedToBeMoved.length }} {{ selectedToBeMoved.length === 1 ? 'item selected' : 'items selected' }}</span>
            </div>
            <small class="text-warning" v-if="selectedToBeMoved.length==0">No Selected Line Items</small>
        </div>
        </div>
        <template v-slot:actions>
            <button type="button" ref="closeBoqMoveLineItemsModal" :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'" data-bs-dismiss="modal">{{ isDeluxeLayout ? 'Cancel' : 'X Cancel' }}</button>
            <button type="button" :class="isDeluxeLayout ? 'custom-btn boq-move-modal__move-btn' : 'btn btn-primary'" v-if="selectedToBeMoved.length!=0" @click="MoveToSection"><i class="fa-solid fa-link"></i> Move</button>
        </template>
    </Modal>
    <Modal idModal="BoqDeleteLineItemsModal" :headerTitle="$t('Delete Line Items')" modalSize="modal-md">
        <p class="mb-0">
            Are you sure you want to delete <strong>{{ selectedToBeMoved.length }}</strong>
            selected {{ selectedToBeMoved.length === 1 ? 'line item' : 'line items' }}? This action cannot be undone.
        </p>
        <template v-slot:actions>
            <button type="button" ref="closeBoqDeleteLineItemsModal" :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'" data-bs-dismiss="modal">{{ isDeluxeLayout ? $t('Cancel') : 'X ' + $t('Cancel') }}</button>
            <button type="button" class="btn btn-danger boq-delete-modal__confirm" :disabled="isDeleting || selectedToBeMoved.length === 0" @click="DeleteLineItemsPermanent">
                <i class="fa-solid fa-trash-can"></i>
                {{ isDeleting ? 'Deleting...' : $t('Delete') }}
            </button>
        </template>
    </Modal>
    <Modal idModal="BoqProcureLineItemsModal" :headerTitle="$t('Procure Line Items')" modalSize="modal-md">
        <div>
            <div class="form-group hle-section-modal-field hle-section-modal-field--display">
                <label>{{ $t('Section Name') }}</label>
                <div class="hle-section-modal-display">
                    <span class="hle-section-modal-display__icon">
                        <i class="fa-solid fa-layer-group"></i>
                    </span>
                    <span class="hle-section-modal-display__value text-capitalize">{{ parentObj.name || '' }}</span>
                </div>
            </div>
            <div class="form-group hle-section-modal-field hle-section-modal-field--display">
                <label>{{ $t('Selected Line Items') }}</label>
                <div class="hle-section-modal-display">
                    <span class="hle-section-modal-display__icon">
                        <i class="fa-solid fa-list-check"></i>
                    </span>
                    <span class="hle-section-modal-display__value">
                        {{ selectedToBeMoved.length }} {{ selectedToBeMoved.length === 1 ? 'item selected' : 'items selected' }}
                    </span>
                </div>
            </div>
            <div class="form-group hle-section-modal-field">
                <label>{{ $t('Combine into Existing Trade Package?') }}</label>
                <div class="hle-section-modal-input">
                    <span class="hle-section-modal-input__icon">
                        <i class="fa-solid fa-boxes-stacked"></i>
                    </span>
                    <select class="form-select" v-model="procureLineItemsForm.existing">
                        <option value="false">{{ $t('No') }}</option>
                        <option value="true">{{ $t('Yes') }}</option>
                    </select>
                </div>
            </div>
            <div class="form-group hle-section-modal-field" v-if="procureLineItemsForm.existing === 'false'">
                <label>{{ $t('New Trade Package Name') }}*</label>
                <input type="text" class="form-control" v-model="procureLineItemsForm.tradePackageName" />
            </div>
            <div class="form-group hle-section-modal-field" v-if="procureLineItemsForm.existing === 'true'">
                <label>{{ $t('Trade Package') }}*</label>
                <Select2
                    indexValue="id"
                    labelName="name"
                    :placeHolder="$t('Select Trade Package')"
                    :dataOptions="nonProcuredTradePackages"
                    v-model:optionValue="procureLineItemsForm.tradePackageId"
                    :willCapitalize="false"
                />
                <small class="text-warning" v-if="nonProcuredTradePackages.length === 0">
                    {{ $t('No data Found') }}
                </small>
            </div>
        </div>
        <template v-slot:actions>
            <button
                type="button"
                ref="closeBoqProcureLineItemsModal"
                :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'"
                data-bs-dismiss="modal"
            >{{ isDeluxeLayout ? $t('Cancel') : 'X ' + $t('Cancel') }}</button>
            <button
                type="button"
                :class="isDeluxeLayout ? 'custom-btn' : 'btn btn-primary'"
                @click="ProcureLineItems"
                :disabled="isOnProcess || selectedToBeMoved.length === 0 || (procureLineItemsForm.existing === 'true' && !procureLineItemsForm.tradePackageId)"
            >
                <i v-if="!isDeluxeLayout" class="fa-solid fa-save"></i>
                {{ isOnProcess ? $t('Loading') : $t('Save') }}
            </button>
        </template>
    </Modal>
  </template>
  
<script>
import Modal from '@/components/layout/Modal.vue'
import Loader from '@/components/layout/Loader.vue'
import Select2 from '@/components/layout/Select2.vue'
import BoqItemTableBreakdown from '@/components/boq/BoqItemTableBreakdown.vue'
import ModalUpdateLineItem from '@/components/boq/ModalUpdateLineItem.vue'
import ModalImportLineItems from '@/components/boq/ModalImportLineItems.vue'
import ModalLineItemColumnFilter from '@/components/boq/ModalLineItemColumnFilter.vue'
import ButtonTemplateDownloader from '@/components/boq/ButtonTemplateDownloader.vue'
import ModalNewLineItem from '@/components/boq/ModalNewLineItem.vue'
import {NumberFormatterWidget, LinkList,LevelSort, ApprovalStageBoq, SortFunc, ModuleActionList ,ReformatDate, ExportTemplates, ApprovalStageBoqObj
,GetDistinctValues,GetDistinctValuesObject} from '@/helpers/utilities.js'
import  {mapActions, mapGetters} from 'vuex'
import BreadcrumbsProject  from '@/components/projectInformation/BreadcrumbsProject.vue'
import 'dotenv/config'
import {GetCostCodes,PublishBoq, SearchAreaFromProject,DownloadBoqExport, GetItemsFromBoqByBits, UpdateNewBoqCreatorSectionBreakdownSequence, GetNewBoqCreatorSectionItem,
   ForApprovalBoq, SearchBoqFromProject, ExportBoqCostXLayout, ExportBoqFiveDLayout, ExportBoqRolledUpLayout, BoQItemExportForInternal, GetNewBoqCreatorSectionsRaw,
   AddUnassignedToNewBoqCreatorSection, DeleteLineItemsNewBoqCreator, GetNonProcuredTradePackagesInProject, ProcureNewBoqCreatorSectionLineItems} from '@/actions/boqActions.js'
import {GetProcessItem} from '@/actions/projectActions.js'
import {measurementUnits} from '@/assets/dataJson/commercial_management.json'
import {SearchAllActiveCostCodes} from '@/actions/projectActions.js'
import FigureCurrencyNote from '@/components/layout/FigureCurrencyNote.vue'
export default {
  name: 'BoqBuilderBreakdown',
  components: {
    BreadcrumbsProject,
    Modal,
    Select2,
    BoqItemTableBreakdown,
    Loader,
    ModalUpdateLineItem,
    ModalImportLineItems,
    ModalNewLineItem,
    ModalLineItemColumnFilter,
    ButtonTemplateDownloader,
    FigureCurrencyNote
  },
  methods:{
    ...mapActions(['SetCostCodes','GetProjectInfo', 'GetBoqItemRun','ChangeActiveLink']),
    ReformatDate : ReformatDate,
    EnsureLandscapePrintStyle(){
      const styleId = 'boq-breakdown-landscape-print'
      let style = document.getElementById(styleId)
      if (!style) {
        style = document.createElement('style')
        style.id = styleId
        document.head.appendChild(style)
      }
      // Keep this stylesheet last so it overrides the shared portrait @page rule.
      style.textContent = '@media print { @page { size: A4 landscape; margin: 10mm 0; } }'
      document.head.appendChild(style)
    },
    PreparePrintTables(){
      this.EnsureLandscapePrintStyle()
      const shell = this.$refs.printTableShell
      if (!shell) return
      shell.querySelector('.boq-print-sections')?.remove()
      const original = shell.querySelector('table')
      if (!original) return
      const clean = original.cloneNode(true)
      clean.querySelectorAll('.d-print-none').forEach(node => node.remove())
      const sections = document.createElement('div')
      sections.className = 'boq-print-sections boq-preliminaries-table'
      sections.appendChild(clean)
      shell.appendChild(sections)
    },
    PrintPage(){
      this.PreparePrintTables()
      window.print()
    },
    FormatStatusLabel(label){
      if(!label){
        return '-'
      }

      return String(label).toLowerCase().replace(/\b\w/g, (char)=>char.toUpperCase())
    },
    GetBoqStatusClass(status){
      switch(Number(status)){
        case 1:
        case 2:
        case 3:
          return 'boq-preliminaries-status--pending'
        case 4:
          return 'boq-preliminaries-status--approval'
        case 5:
        case 8:
          return 'boq-preliminaries-status--approved'
        case 6:
          return 'boq-preliminaries-status--revision'
        default:
          return 'boq-preliminaries-status--neutral'
      }
    },
    SyncSelectedLineItem(data){
      this.selectedToBeMoved = data
    },
    GetMoveSectionById(sectionId){
      return this.rawSections.find(item => String(item._id || item.id || '') === String(sectionId || ''))
    },
    GetMoveSectionName(sectionId, fallback = 'the selected section'){
      const section = this.GetMoveSectionById(sectionId)
      return section?.name ? `"${section.name}"` : fallback
    },
    GetMoveSectionValidationMessage(selected){
      const selectedId = String(selected || '')

      if(!selectedId){
        return ''
      }

      if(String(this.parentId || '') === selectedId){
        return 'The selected line item is already in this section. Please choose a different destination section.'
      }

      const selectedSection = this.GetMoveSectionById(selectedId)
      if(Number(selectedSection?.level) === 1){
        return `Line items must be moved into a sub-section. ${this.GetMoveSectionName(selected)} is a main section, so please select one of its sub-sections first.`
      }

      const selectedHasChildSections = this.rawSections.some(item => String(item.parentId || '') === selectedId)
      if(selectedHasChildSections){
        return `Line items can only be moved into a final sub-section. ${this.GetMoveSectionName(selected)} contains sub-sections, so please choose one of its child sections.`
      }

      return ''
    },
    FormatMoveSectionError(result, selected){
      const rawMessage = String(result || '').trim()
      const normalizedMessage = rawMessage.toLowerCase()

      if(normalizedMessage.indexOf('cannot put line items in this section') > -1){
        return `Line items cannot be moved directly into ${this.GetMoveSectionName(selected)}. Please choose a final sub-section that does not contain any child sections.`
      }

      if(normalizedMessage.indexOf('unauthorized') > -1){
        return 'You do not have permission to move line items in this Bill of Quantity.'
      }

      return rawMessage || 'The selected line items could not be moved. Please review the destination section and try again.'
    },
    async MoveToSection(){
      const self  = this
      if(self.isOnProcess){
          return
      }  
      const swalTitle = self.$i18n.t('Move to Section')

      const selected = self.selectedThirdSection || self.selectedSecondSection || self.selectedFirstSection

      if(self.selectedToBeMoved.length==0){
          self.$swal(swalTitle, self.$i18n.t('No line item selected'), 'warning')
          return
      }

      if(!selected){
          self.$swal(swalTitle, self.$i18n.t('Please Select'), 'warning')
          return
      }

      const validationMessage = self.GetMoveSectionValidationMessage(selected)
      if(validationMessage){
          self.$swal(swalTitle, validationMessage, 'warning')
          return
      }

      const result = await AddUnassignedToNewBoqCreatorSection({
          boqId : self.boqListParams.id,
          lineItems : self.selectedToBeMoved,
          parentId : selected
      })

      if(result!='OK'){
          self.$swal(swalTitle, self.FormatMoveSectionError(result, selected), 'warning')
          return
      }
      self.selectedToBeMoved = []

      self.$swal(swalTitle, self.$i18n.t('Line Items Moved Successfully'), 'success')
      setTimeout(function(){
        location.reload()
      },700)
    },
    
    async DeleteLineItemsPermanent(){
        const self  = this
        if(self.isDeleting){
            return
        }  
        const swalTitle = self.$i18n.t('Delete Line Items')
        if(self.selectedToBeMoved.length==0){
            self.$swal(swalTitle, self.$i18n.t('No line item selected'), 'warning')
            return
        }

        self.isDeleting = true
        try {
            const deletePayload = {
                boqId : self.boqListParams.id,
                lineItems : self.selectedToBeMoved,
            }
            const result = await DeleteLineItemsNewBoqCreator(deletePayload)

            if(result!='OK'){
                self.$swal(swalTitle, result, 'warning')
                return
            }

            self.selectedToBeMoved = []
            self.$refs.closeBoqDeleteLineItemsModal.click()
            self.$swal(swalTitle, self.$i18n.t('Deleted Successfully'), 'success')
            setTimeout(function(){
              location.reload()
            },700)
        } finally {
            self.isDeleting = false
        }
    },
    async OpenProcureLineItems(){
      const self = this
      if(self.selectedToBeMoved.length === 0){
        return
      }

      self.procureLineItemsForm = {
        existing: 'false',
        tradePackageId: '',
        tradePackageName: self.parentObj.name
      }

      const getTrades = await GetNonProcuredTradePackagesInProject(self.boqItemData.projectId)
      self.nonProcuredTradePackages = Array.isArray(getTrades) ? getTrades : []

      self.$nextTick(()=>{
        self.$refs.openBoqProcureLineItemsModal?.click()
      })
    },
    async ProcureLineItems(){
      const self = this
      if(self.isOnProcess){
        return
      }

      const swalTitle = self.$i18n.t('Procure Line Items')

      if(self.selectedToBeMoved.length === 0){
        self.$swal(swalTitle, self.$i18n.t('No line item selected'), 'warning')
        return
      }

      if(self.procureLineItemsForm.existing === 'true' && !self.procureLineItemsForm.tradePackageId){
        self.$swal(swalTitle, self.$i18n.t('No trade package selected'), 'warning')
        return
      }
      if(!self.procureLineItemsForm.tradePackageName && self.procureLineItemsForm.existing === 'false'){
        self.$swal(swalTitle, self.$i18n.t('No trade package name provided'), 'warning')
        return
      }

      self.isOnProcess = true
      try {
        const procureResult = await ProcureNewBoqCreatorSectionLineItems({
          id: self.parentId,
          boqId: self.boqListParams.id,
          lineItemIds: self.selectedToBeMoved,
          tradePackageId: self.procureLineItemsForm.existing === 'true'
            ? self.procureLineItemsForm.tradePackageId
            : null,
          tradePackageName: self.procureLineItemsForm.existing === 'false' ? self.procureLineItemsForm.tradePackageName : null
        })

        if(procureResult != 'OK'){
          self.$swal(swalTitle, procureResult, 'warning')
          return
        }

        self.selectedToBeMoved = []
        self.$refs.closeBoqProcureLineItemsModal?.click()
        self.$swal(swalTitle, self.$i18n.t('Success!'), 'success')
        setTimeout(function(){
          location.reload()
        },700)
      } finally {
        self.isOnProcess = false
      }
    },
    ChangeSection(level){
        const self = this
        if(level==1){
            const selected = self.selectedFirstSection

            self.secondSections = self.rawSections.filter(u=>u.parentId==selected)
            self.thirdSections = []

            self.selectedSecondSection = ''
            self.selectedThirdSection = ''
        }else if(level==2){
            const selected = self.selectedSecondSection

            self.thirdSections = self.rawSections.filter(u=>u.parentId==selected)

            self.selectedThirdSection = ''
        }
    },
    CancelSaveSequence(){
      window.location.reload()
    },
    SaveSequences(){
      const self = this
      self.$refs.tableBreakdown.PassData()
    },
    async GetSequence(data){

      const self = this
      self.rowDataSequence = data

      let toBeSaved = []

      for(let x =0; x<data.length;x++){
        const getData = data[x]
        if(getData.sequenceStack!=x){
          toBeSaved.push({
            id : getData._id,
            sequence : x
          })
        }
      }

      if(toBeSaved.length==0){
        return
      }

      const result = await UpdateNewBoqCreatorSectionBreakdownSequence({
        boqId : self.boqListParams.id,
        parentId : self.parentId,
        lineItems : toBeSaved,
      }) 
      const swalTitle = self.$i18n.t('Save Sequence')

      if(result=='OK'){
        self.$swal(swalTitle, self.$i18n.t('Sequence Saved successfully, please wait Page is Reloading'),'success')
        setTimeout(function(){ location.reload() },1000)
      }else{
        self.$swal(swalTitle, result,'warning')
      }
    },
    GetChanges(){
      this.haveChanges = true
    },
    timerSetter(callback){
        const self = this
        if(self.timer){
            clearTimeout(self.timer)
            self.timer = null
        }
        self.timer = setTimeout(callback,700)
    },
    timerSetterSearch(callback){
      const self = this
      
      if(self.timerSearch){
          clearTimeout(self.timerSearch)
          self.timerSearch = null
      }

      self.timerSearch = setTimeout(callback,700)
    },
    GetCostCodeRun(search){
      return GetCostCodes(search,this.newTabData.parent)
    },
    formatNumber(value,sign= ""){
      return NumberFormatterWidget(value,sign)
    },
    
    SendForNewWorkFlow(){
      this.$router.push({name : 'BoqReviewerSetup', query : { boqId : this.$route.params.id} })
    },
    ForApprovalBoqRun(e){
      const self = this
      const btn = e.target
      const boqId = self.$route.params.id
      if(self.isApprovalRunning){
        return
      }
      self.isApprovalClicked =true

      const newData = self.boqApprovalData

      if(!newData.processId || !newData.dateEnd){
        return
      }
      btn.disabled = true
      newData.boqId  = boqId

      self.isApprovalClicked = false
      self.isApprovalRunning = true

      ForApprovalBoq(newData).then((res)=>{
        self.isApprovalRunning = false
        btn.disabled = false
        if(res!='OK'){
          self.$swal('Bill Of Quantites Approval', res,'warning')
        }else{
            self.GetBoqItemRun(boqId).then((res)=>{
                self.boqItemData = res
                GetProcessItem(boqId,1).then((process)=>{
                  self.processItemData = process
                  self.$refs.closeBoqApprovalModal.click()
                }).catch()
            })
            
        }
      }).catch()
    },
    SelectArea(area){
      const self = this
      const selected = self.selectedArea

      const getIndex = selected.indexOf(area)
      if(getIndex==-1){
        selected.push(area)
      }else{
        selected.splice(getIndex,1)
      }

      self.selectedCostCode = []
      if(selected.length==0){
        self.boqListParams = {
          id : self.$route.params.id,
          costCode : encodeURIComponent(JSON.stringify([self.boqItemData.subCategoryList[0].costCodeId])),
          area : '',
          page : 1
        }
        self.selectedCostCode.push(self.boqItemData.subCategoryList[0].costCodeId)
      }else{
        self.boqListParams = {
          id : self.$route.params.id,
          costCode : '',
          area : encodeURIComponent(JSON.stringify(selected)),
          page : 1
        }
      }

      self.tableLoading = true
      self.timerSetter(async function(){
        self.rowDatas = []
        self.boqListParams.skip = 0
        await self.GetListByBites()
        self.tableLoading = false
      })
    },
    SelectCostCode(costCode){
      const self = this

      const getIndex = self.selectedCostCode.findIndex(u=>u===costCode)
      if(getIndex==-1){
        self.selectedCostCode.push(costCode)
      }else{
        self.selectedCostCode.splice(getIndex,1)
      }

      self.boqListParams = {
        id : self.$route.params.id,
        costCode : encodeURIComponent(JSON.stringify(self.selectedCostCode)),
        area : '',
        page : 1
      }
      self.selectedArea = []
      self.tableLoading = true
      self.timerSetter(async function(){
        self.rowDatas = []
        self.boqListParams.skip = 0
        await self.GetListByBites()
        self.tableLoading = false
      })
    },
    ChangeView(val){
      this.filterView = val
    },
    async ReloadList(){
      const self = this
      self.tableLoading = true
      self.rowDatas = []
      self.boqListParams.skip = 0
      await self.GetListByBites()
      self.tableLoading = false
      
    },
    PageChange(page){
      const self = this
      self.boqListParams.page = page
      self.tableLoading = true
    },
    OpenEditModal(data){
      this.updateMasterItem = Object.assign({},data)
      this.updateMasterItem.costName = data.costCode + ' ' + data.name 
      this.updateMasterItem.subCateg = data.parents[1].name
      this.updateMasterItem.mainCateg = data.parents[0].name
    },
    SearchArea(e){
        const self = this

        self.timerSetter(function(){
            SearchAreaFromProject({id : self.projectInfo._id, search : e.target.value}).then((res)=>{
                self.areaList = res
            })
        })
    },
    GetProcessItemRun(){
      const self = this
      const boqId = self.$route.params.id
      self.GetBoqItemRun(boqId).then((res)=>{
          self.boqItemData = res
          GetProcessItem(boqId,1).then((process)=>{
            self.processItemData = process
          }).catch()
      })
    },
    OpenApproval(){
      this.boqApprovalData ={}
    },
    OpenReviewer(){
      this.boqPublishData ={}
    },
    PublishBoqItems(e){
      const self = this
      const btn = e.target
      const boqId =  self.$route.params.id


      self.$swal({
        title: 'Publish BoQ',
        text : 'BoQ will be locked for changed, Proceed?',
        showCancelButton: true,
        icon: 'warning',
        confirmButtonText: 'Proceed',
        showLoaderOnConfirm : true,
        allowOutsideClick: () => !self.$swal.isLoading(),
        preConfirm : ()=>{
          btn.disabled = true
          return PublishBoq(boqId).then((res)=>{
            btn.disabled = false
            if(res=="OK"){
              self.GetBoqItemRun(boqId).then((res)=>{
                  self.boqItemData = res
              })
            }else{
              self.$swal('Publish BoQ',res,'warning')
            }
          })
      }
      }).then((res)=>{
        if(res.isConfirmed){
          self.$swal('Boq Published Successfully','','success')
        }
      })
    },
    GetDataList(){
      const self= this
      self.tableLoading = true
      self.GetBoqItemRun(self.$route.params.id).then(async (res)=>{
        self.boqItemData = res
        self.boqItemData.subCategoryList.sort(LevelSort)
        self.boqItemData.areaList.sort(SortFunc)
        await self.GetListByBites()
        self.tableLoading = false
        // GetItemsFromBoq(self.boqListParams).then((data)=>{
        //   self.tableLoading = false
        //   self.rowDatas = data
        // })
      })
    },
    async GetListByBites(){
      const self = this

      self.rowDatas = []
      let willFetch = true
      self.boqListParams.skip = 0
      self.dataReady = false
      while(willFetch){
          const bits = await GetItemsFromBoqByBits(self.boqListParams)
          if(bits.length!=0){
              self.rowDatas.push(...bits)
          }
          if(bits.length==self.boqListParams.take){
              self.boqListParams.skip += 50
          }else{
              willFetch = false
          }
      }

      self.dataReady = true
    },
    OpenEditLineItem(data){
      this.updateLineItem = JSON.parse(JSON.stringify(data))
      this.updateLineItem.id = data._id
      this.updateLineItem.markUp = (this.updateLineItem.markUp * 100).toFixed(2)
    },
    OpenImportModal(){
      this.$refs.modalImportLineItem.ClearData()
    },
    OpenAddItemModal(){
      this.$refs.modalNewLineItem.ClearData()
    },
    ChangeSelectecColumnValue(value){
      this.selectedColumns = value
    },
    async ExportBoqList(){
      if(this.isExportRunning){
        return
      }

      const boqId = this.$route.params.id
      const exportName = this.boqItemData.name
      this.isExportRunning = true
      try{
        if(this.exportTemplateType===0){
          await DownloadBoqExport(boqId, exportName +' export')
        }else if(this.exportTemplateType===1){
          await ExportBoqFiveDLayout(boqId, exportName + ' FiveD-export')
        }else if(this.exportTemplateType===2){
          await ExportBoqCostXLayout(boqId, exportName + ' costX-export')
        }else if(this.exportTemplateType===3){
          await BoQItemExportForInternal(boqId, exportName + ' internal-export')
        }else{
          this.$swal(this.$i18n.t('Export Template'),this.$i18n.t('Sorry not yet implemented'),'warning')
        }
      }finally{
        this.isExportRunning = false
      }
    },
    ExportForClient(e){
      const self = this
      const btn = e.target
      const boqId = self.$route.params.id
      btn.disabled = true
      ExportBoqRolledUpLayout(boqId, self.boqItemData.name + ' export').then(()=>{
        btn.disabled = false
      })
    },
    UpdateSelected(data){
      this.selectedLineItems = data
    },
    SearchCostCodeAll(query){
      const self =  this
      self.searchCostCodeLoading = true
      self.timerSetter(function(){
          self.searchCostCodeLoading = false
          SearchAllActiveCostCodes(query).then((res)=>{
              self.dataCostCodes = res
          })
      })
    },
    ClearField(type){
      if(type==1){
          this.selectedArea = []
      }
      else{
          this.selectedCostCode = []
      }
    },
  },
  watch: {
    selectedCostCode(val) {
        const self = this
        self.boqListParams.costCode = encodeURIComponent(JSON.stringify(val.map(u=>u._id)))
        self.boqListParams.area = encodeURIComponent(JSON.stringify(self.selectedArea))
        self.timerSetterSearch(async function(){
          self.rowDatas = []
          self.boqListParams.skip = 0
          await self.GetListByBites()
          self.tableLoading = false
        })

        return val.map(u=>u._id)
    },
    selectedArea(val){
      const self = this
      self.boqListParams.costCode = encodeURIComponent(JSON.stringify(self.selectedCostCode))
      self.boqListParams.area = encodeURIComponent(JSON.stringify(val))
      self.timerSetterSearch(async function(){
        self.rowDatas = []
        self.boqListParams.skip = 0
        await self.GetListByBites()
        self.tableLoading = false
      })

      return val
    }
  },
  beforeUnmount(){
    window.removeEventListener('beforeprint', this.PreparePrintTables)
    document.getElementById('boq-breakdown-landscape-print')?.remove()
  },
  mounted : async function(){
    window.addEventListener('beforeprint', this.PreparePrintTables)
    const self = this
    self.ChangeActiveLink(LinkList.BILL_OF_QUANTITIES)
    const boqId = self.$route.params.id
    const boqItem = await self.GetBoqItemRun(boqId)
    self.ExportTemplatesForExport = [...ExportTemplates]
    self.ExportTemplatesForExport.push('System Template(For Presentation)')
    if(boqItem==401){
      self.$router.push('/unauthorized')
      return
    }
    self.boqItemData = boqItem
    self.parentObj = await GetNewBoqCreatorSectionItem({id : self.parentId,boqId : boqId})
    await self.GetListByBites()
    
    if(!self.projectInfo._id){
      await self.GetProjectInfo(boqItem.projectId).catch()
    }
    // if(boqItem.approvalStage==ApprovalStageBoq.FOR_APPROVAL){
    //   const processData = await GetProcessItemBoq(boqId).catch()
    //   self.processItemData = processData
    // }

    const rawSections = await GetNewBoqCreatorSectionsRaw(boqItem._id)
    self.rawSections = rawSections.sections
    self.firstSections = rawSections.sections.filter(u=>u.level==1)

    self.boqList = await SearchBoqFromProject({search : '', id : boqItem.projectId})
    
    const lineItemCols =  window.localStorage.getItem('lineItemColumns')
    if(lineItemCols){
        this.selectedColumns = lineItemCols.split(',').map(Number)
    }
    // self.SearchCostCodeAll('')
    // self.areaList = await SearchAreaFromProject({id : self.projectInfo._id, search : ''})
    // self.areaList.push('NO SPACE ID')
    self.areaList = GetDistinctValues(self.rowDatas.map(u=>u.area).filter(value => value !== null && value !== undefined && value !== ''))
    self.areaList.push(self.$i18n.t('NO SPACE ID'))
    const getLineItemCostCode = 
        self.userInfo.language =='en' ? 
            self.rowDatas.map(u=>{
                return {
                    _id : u.costCodeId,
                    costName : u.costCode + ' ' +u.name
                }
            }) 
        :
            self.rowDatas.map(u=>{
                return {
                    _id : u.costCodeId,
                    costName : u.costCode + ' ' +u.nameCh
                }
            }) 
    self.dataCostCodes = GetDistinctValuesObject(getLineItemCostCode)
  },
  computed : {
    ...mapGetters(['projectInfo', 'permission','userInfo']),
    isDeluxeLayout(){
      return this.$route.meta.layout == 'deluxe'
    },
    referenceTitle(){
      const reference = this.boqItemData.reference
      if(!reference){
        return this.boqItemData.referenceNo || this.boqItemData.name || ''
      }
      if(typeof reference === 'string'){
        return reference
      }

      return reference.name || reference.quotationName || reference.title || reference.reference || reference.quotationNo || this.boqItemData.referenceNo || this.boqItemData.name || ''
    },
    referenceStatusLabel(){
      const stage = this.boqItemData.reference?.approvalStage
      if(!stage){
        return ''
      }

      return this.FormatStatusLabel(ApprovalStageBoqObj[stage - 1]?.name)
    },
    IsQuotationPublished(){
      // return this.boqItemData.reference?.approvalStage==ApprovalStageBoq.PUBLISHED
      return this.boqItemData.approvalStage === ApprovalStageBoq.APPROVED
    }
  },
  data(){
    return {
      selectedToBeMoved : [],
      nonProcuredTradePackages : [],
      procureLineItemsForm : {
        existing : 'false',
        tradePackageId : '',
        tradePackageName: ''
      },
      isOnProcess : false,
      rawSections : [],
      firstSections : [],
      secondSections : [],
      thirdSections : [],
      selectedFirstSection : '',
      selectedSecondSection : '',
      selectedThirdSection : '',
      rowDataSequence : [],
      ApprovalStageBoqObj : ApprovalStageBoqObj,
      OpenFilter : false,
      ModuleActionList : ModuleActionList,
      boqItemData :{
        _id : '1',
        subCategoryList : [],
        areaList : [],
        approvalStage : 1,
        reference : {}
      },
      areaList : [],
      selectedArea : [],
      selectedCostCode : [],
      dataCostCodes : [],
      parentId : this.$route.params.parent,
      parentObj : {},
      boqListParams : {
        id : this.$route.params.id,
        parent : this.$route.params.parent,
        costCode : '',
        area : '',
        page : 1,
        take : 50,
        skip : 0
      },
      boqPublishData : {},
      boqApprovalData : {
        boqId : this.$route.params.id
      },
      isPublishRunning : false,
      isPublishClicked : false,
      isApprovalRunning : false,
      isApprovalClicked : false,
      isExportRunning : false,
      isDeleting : false,
      timer : null,
      timerSearch : null,
      rowDatas:[],
      BoqCategoryList : [],
      dataReady : false,
      tableLoading : false,
      projectUrl : process.env.VUE_APP_PROJECT_URL,
      dotnetUrl : process.env.VUE_APP_DOTNET_URL,
      boqUrl : process.env.VUE_APP_BOQ_URL,
      filterView : 1,
      ApprovalStageBoq : ApprovalStageBoq,
      measurementUnits : measurementUnits,
      processItemData : {
        status : 1,
        internalApprovers : [],
        externalApprovers: []
      },
      boqList : [],
      updateLineItem : {
        unit : '',
        parents : [
            {
                name : ''
            },
            {
                name : ''
            }
        ]
      },
      selectedColumns : [],
      ExportTemplates : ExportTemplates,
      ExportTemplatesForExport : [],
      exportTemplateType : 0,
      exportTemplateFilter : null,
      selectedLineItems : [],
      selectedParent : "",
      approvalProcessList : [],
      reviewProcessList : [],
      searchCostCodeLoading : false,
      movedLineItems : [],
      haveChanges : false,
    }
  },
}
</script>

<style>
@media screen and (min-width: 1200px) {
  .deluxe-layout.theme-boq .content__wrapper:has(.boq-preliminaries-page) {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .deluxe-layout.theme-boq .boq-preliminaries-page {
    max-width: none;
  }

  .deluxe-layout.theme-boq .boq-preliminaries-page .boq-preliminaries-hero,
  .deluxe-layout.theme-boq .boq-preliminaries-page .boq-preliminaries-body {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
}
</style>

<style>
@media print {
  .boq-preliminaries-table-shell:has(.boq-print-sections) > .boq-preliminaries-table:not(.boq-print-sections) { display: none !important; }
  .boq-print-sections { display: block !important; }
  .deluxe-layout.theme-boq .boq-print-sections .table :is(th, td) {
    font-size: 5.5pt !important;
    line-height: 1.1 !important;
  }
  .deluxe-layout.theme-boq .boq-print-sections .table th {
    font-size: 3pt !important;
    line-height: 1 !important;
    letter-spacing: -0.1pt !important;
    overflow-wrap: anywhere !important;
    padding: 0.75pt !important;
  }
  .deluxe-layout.theme-boq .boq-preliminaries-table.boq-print-sections .table > thead > tr > th {
    text-transform: none !important;
  }
  .deluxe-layout.theme-boq .boq-print-sections .table td.line-item-100 { white-space: nowrap !important; }

  body:has(.boq-preliminaries-page),
  .deluxe-layout.theme-boq:has(.boq-preliminaries-page) :is(.wrapper, .wrapper__inner, .content, .content__wrapper),
  .deluxe-layout.theme-boq .boq-preliminaries-page :is(.boq-preliminaries-body, .boq-preliminaries-table-shell, .boq-preliminaries-table.table-responsive) {
    height: auto !important;
    max-height: none !important;
    min-width: 0 !important;
    overflow: visible !important;
  }

  .deluxe-layout.theme-boq .boq-preliminaries-table .table {
    width: 100% !important;
    min-width: 0 !important;
    table-layout: fixed !important;
  }

  .deluxe-layout.theme-boq .boq-preliminaries-table .table :is(th, td) {
    width: auto !important;
    min-width: 0 !important;
    max-width: none !important;
    white-space: normal !important;
    overflow-wrap: normal;
    padding: 1.5pt !important;
  }

  .deluxe-layout.theme-boq .boq-preliminaries-table .table .boq-col-serial { width: 2% !important; }
  .deluxe-layout.theme-boq .boq-preliminaries-table .table .boq-col-description { width: 12% !important; }
  .deluxe-layout.theme-boq .boq-preliminaries-table .table .boq-col-image { width: 5% !important; }
  .deluxe-layout.theme-boq .boq-preliminaries-table .table :is(th, td):nth-child(4) { width: 4% !important; }
  .deluxe-layout.theme-boq .boq-preliminaries-table .table :is(th, td):nth-child(5) { width: 3% !important; }
  .deluxe-layout.theme-boq .boq-preliminaries-table :is(.boq-image-cell-button, .boq-image-cell-frame, .boq-image-cell-preview, .boq-image-cell-button--disabled) {
    width: 100% !important;
    min-width: 0 !important;
    height: auto !important;
    min-height: 0 !important;
    max-height: 18mm;
    object-fit: contain;
  }
  .deluxe-layout.theme-boq .boq-preliminaries-table tr {
    break-inside: avoid;
    page-break-inside: avoid;
  }
}
</style>

<style>
@media screen { .boq-print-sections { display: none; } }
</style>
